import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { DashboardConfigService } from '@/services/DashboardConfigService';

import { IDashboardConfig } from '@/store/models/dashboard-config.model';

import {
  DashboadConfigActionTypes,
  TDashboardConfigAction,
  IDashboardConfigState,
} from '@/store/types/dashboard-config.types';
import { TAppError } from '@/store/types/base.state';

export const getDashboardConfig = (): ThunkAction<Promise<void>, IDashboardConfigState, {}, TDashboardConfigAction> => {
  const request = (): TDashboardConfigAction => ({
    type: DashboadConfigActionTypes.GET_DASHBOARD_CONFIG,
  });
  const fail = (error: TAppError): TDashboardConfigAction => ({
    type: DashboadConfigActionTypes.GET_DASHBOARD_CONFIG_FAIL,
    error,
    documentation: 'https://docs.treezor.com/guide/dashboard/configuration.html#general-configuration',
  });
  const success = (config?: IDashboardConfig): TDashboardConfigAction => ({
    type: DashboadConfigActionTypes.GET_DASHBOARD_CONFIG_SUCCESS,
    shouldSkipToaster: true,
    config,
  });

  return async (dispatch: ThunkDispatch<IDashboardConfigState, {}, TDashboardConfigAction>): Promise<void> => {
    dispatch(request());
    try {
      const config = await DashboardConfigService.getDashboardConfig();
      dispatch(success(config));
    } catch (error) {
      console.error({ error });
      dispatch(fail(error));
    }
  };
};
